import {
  Box,
  Image,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import {CloseIcon} from "@chakra-ui/icons";

export default function PreviewFile({preview, setPreview}) {
  const toast = useToast();
  const getFileType = (fileName) => {
    const ext = fileName
      .slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();
    const fileTypes = {
      image: ["jpg", "png", "jpeg"],
      pdf: ["pdf"],
      office: ["doc", "docx"],
      //video: ["mp4", "mov", "avi"],
      //audio: ["mp3", "wav", "ogg"],
      text: ["txt", "csv", "json", "js", "ts", "html", "css", "py"],
    };
    return (
      Object.keys(fileTypes).find((key) => fileTypes[key].includes(ext)) ||
      "unsupported"
    );
  };

  const fileType = preview && getFileType(preview?.fileName);

  if (fileType === "unsupported") {
    toast({
      title: "Unsupported file type",
      description:
        "This file is in an incompatible format, and therefore cannot be previewed. Please download it to view.",
      status: "warning",
      isClosable: true,
    });
    setPreview(false);
    return null;
  }

  const renderPreview = () => {
    switch (fileType) {
      case "image":
        return <Image src={preview.data} m="auto" />;
      case "pdf":
        return (
          <Box as="iframe" src={preview.data} width="full" height="full" />
        );
      case "office":
        return (
          <Box as="iframe" src={preview.data} width="full" height="full" />
        );
      case "video":
        return (
          <Box
            as="video"
            controls
            src={preview.data}
            width="full"
            height="full"
            m="auto"
          />
        );
      case "audio":
        return (
          <Box
            as="audio"
            controls
            src={preview.data}
            width="full"
            height="full"
          />
        );
      case "text":
        return (
          <Box
            as="textarea"
            readOnly
            value={preview.data}
            width="full"
            height="full"
            p={4}
          />
        );
      default:
        return null;
    }
  };

  return (
    preview && (
      <Box
        position="fixed"
        w="full"
        h="full"
        bg="rgba(0,0,0,0.5)"
        left={0}
        top={0}
        zIndex={50}
        p={4}
      >
        <IconButton
          icon={<CloseIcon />}
          aria-label="Close preview"
          position="absolute"
          top={2}
          right={2}
          onClick={() => {
            setPreview(false);
          }}
        />
        <Box h="full" w="100%" overflow="auto" p={4}>
          {renderPreview()}
        </Box>
      </Box>
    )
  );
}
